export async function fadeOut(element) {
  element.classList.add("opacity-0");
  element.classList.add("pointer-events-none");
  element.classList.remove("opacity-100");
  element.classList.remove("pointer-events-auto");
  await sleepAnimation(element);
  return;
}

export async function fadeIn(e) {
  e.classList.remove("opacity-0", "pointer-events-none");
  e.classList.add("opacity-100");
  e.classList.add("pointer-events-auto");
  await sleepAnimation(e);
  return;
}

export async function fadeOutText(element) {
  element.classList.add("text-opacity-0");
  await sleepAnimation(element);
  return;
}

export async function fadeInText(element) {
  element.classList.remove("text-opacity-0");
  await sleepAnimation(element);
  return;
}

export async function hide(element) {
  element.classList.add("hidden");
  return;
}

export async function unHide(element) {
  element.classList.remove("hidden");
  return;
}

export async function disableScroll() {
  document.body.classList.add("overflow-hidden");
  return;
}

export async function enableScroll() {
  document.body.classList.remove("overflow-hidden");
  return;
}

async function sleepAnimation(element) {
  return await sleep(getAnimationDuration(element));
}

function getAnimationDuration(element) {
  const durationClass = [...element.classList].find((item) => item.includes("duration"));
  if (!durationClass) {
    return 0;
  }
  return durationClass.replace("duration-", "");
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
